var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55029 2.62109C7.42367 2.62109 7.86035 3.05778 7.86035 3.93115V37.9927C7.86035 38.866 7.42367 39.3027 6.55029 39.3027C5.67692 39.3027 5.24023 38.866 5.24023 37.9927V3.93115C5.24023 3.05778 5.67692 2.62109 6.55029 2.62109ZM23.5811 17.1392L28.8213 16.6649V6.91809L23.5811 6.44647V17.1365V17.1392ZM20.9609 17.3776V6.20541L13.1006 5.49012V6.55127H10.4805V2.62109L35.7279 4.91632C36.7046 5.00524 37.6128 5.45612 38.274 6.1804C38.9353 6.90468 39.3019 7.85003 39.3018 8.83077V14.7522C39.3019 15.733 38.9353 16.6783 38.274 17.4026C37.6128 18.1269 36.7046 18.5778 35.7279 18.6667L10.4805 20.9619V9.17139H13.1006V18.0929L20.9609 17.3776ZM31.4414 16.4265L35.4895 16.0597C35.8157 16.0302 36.119 15.8796 36.3396 15.6376C36.5603 15.3956 36.6823 15.0797 36.6816 14.7522V8.83077C36.6817 8.50372 36.5593 8.18849 36.3387 7.94704C36.1181 7.70559 35.8152 7.55539 35.4895 7.52595L31.4414 7.15914V16.4265Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW4);
export default __webpack_public_path__ + "static/media/w4.7007ab3111b5b30e91cf3d728c0f4a18.svg";
export { ForwardRef as ReactComponent };